import { uppercaseMarketRegion } from '../../../common/utilities';
import { getPricingApiConfig } from '../config/actions';
/**
 * @internal
 */
export var getSFCCFormattedPriceUrlGet = function (priceVal) {
    var _a = getPricingApiConfig(), sfccBaseUrl = _a.sfccBaseUrl, marketLocale = _a.marketLocale;
    var sfccLocale = uppercaseMarketRegion(marketLocale || '', '_');
    return sfccBaseUrl + "/" + sfccLocale + "/" + "Price-GetFormatted" /* FormattedPrice */ + "?priceVal=" + priceVal;
};
